import React from "react";
import { Switch } from "@material-ui/core";
import PopperCustomMenu from "../../../components/Popper/PopperCustomMenu";
import PencilIcon from "../../../components/Icon/Pencil";
import DuplicaIcon from "../../../components/Icon/DuplicaIcon";
import AtivaIcon from "../../../components/Icon/AtivaIcon";
import DesativaIcon from "../../../components/Icon/DesativaIcon";

export const pageableDTODefault = {
  pageNumber: 0,
  pageSize: 30,
  sortField: "descricao",
  sortDir: "ASC",
};

export const notificationDefault = {
  open: false,
  message: "",
  type: "",
};

export const motivoCancelamentoDefault = {
  descricao: "",
  ativo: true,
};

export const columns = ({ functions }) => [
  {
    Header: "Descrição",
    getValue: (motivoCancelamento) => motivoCancelamento.descricao,
    props: { component: "th", scope: "row" },
    field: "descricao",
  },
  {
    Header: "Status",
    getValue: (motivoCancelamento) => {
      return <Switch id={`cfg-mca-swt-sta-${motivoCancelamento.id}`} checked={motivoCancelamento.ativo} color="primary" />;
    },
    props: { component: "th", scope: "row" },
  },
  {
    Header: "Ação",
    isClick: true,
    getValue: (motivoCancelamento) => {
      return (
        <PopperCustomMenu
          id={`cfg-mca-pop-aca-${motivoCancelamento.id}`}
          colorButton={{ background: "transparent" }}
          menuOpcoes={menuOpcoesMotivosCancelamento({
            functions: {
              handleEdit: () => functions.handleEdit(motivoCancelamento.id),
              handleDuplicar: () =>
                functions.handleDuplicar(motivoCancelamento.id),
              handleDesativar: () =>
                functions.handleDesativar(motivoCancelamento),
              handleAtivar: () => functions.handleAtivar(motivoCancelamento),
            },
            desativado: !motivoCancelamento.ativo,
            isEdit: true,
            element: motivoCancelamento,
          })}
          closePopperAfterClickOption
        />
      );
    },
    props: { component: "th", scope: "row" },
  },
];

export const menuOpcoesMotivosCancelamento = (options) => {
  const optionsMenu = [
    {
      ativo: options.isEdit,
      label: "Editar",
      onClick: () => options?.functions?.handleEdit(),
      icon: <PencilIcon id={`cfg-mca-ico-edi-${options.element.id}`} size="24" color="#505050" />,
    },
    {
      ativo: true,
      label: "Duplicar",
      onClick: () => options?.functions?.handleDuplicar(),
      icon: <DuplicaIcon id={`cfg-mca-ico-dup-${options.element.id}`} size="24" color="#505050" />,
    },
    {
      ativo: options.desativado,
      label: "Ativar",
      onClick: () => options?.functions?.handleAtivar(),
      icon: <AtivaIcon id={`cfg-mca-ico-ati-${options.element.id}`} size="24" color="#505050" />,
    },
    {
      ativo: !options.desativado,
      label: "Desativar",
      onClick: () => options?.functions?.handleDesativar(),
      icon: <DesativaIcon id={`cfg-mca-ico-des-${options.element.id}`} size="24" color="#505050" />,
    },
  ];
  return optionsMenu;
};
